import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#084384',
    },
  },
  typography: {
    fontFamily: ['Roboto', 'sans-serif'].join(','),
  },
  components: {},
  global: {
    pageLeftMargin: 30,
    pageRightMargin: 30,
  },
});

export default theme;
